import { Lines, Overline, FadeUp } from "./Reveal";

export const Process = ({ t }) => (
  <section id="process" className="py-28 md:py-44 border-t border-ink/10" data-testid="process-section">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <Overline className="mb-20 md:mb-28">{t.process.overline}</Overline>
      <div className="space-y-24 md:space-y-36">
        {t.process.chapters.map((ch, i) => (
          <div key={i} className="grid grid-cols-12 gap-6" data-testid={`process-chapter-${i}`}>
            <div className={`col-span-12 md:col-span-7 ${i === 1 ? "md:col-start-5" : i === 2 ? "md:col-start-3" : ""}`}>
              <Lines lines={[ch.title]} className="font-serif text-3xl md:text-5xl lg:text-[3.2vw] leading-[1.18] tracking-tight text-ink" />
              <FadeUp delay={0.2}>
                <p className="font-sans text-sm md:text-base leading-relaxed text-ink/60 max-w-xl mt-8">{ch.text}</p>
              </FadeUp>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
